import { getApiClient } from './apiClient'

export const logout = async (): Promise<void> => {
  await getApiClient().post('/auth/token?type=user&action=logout')
}
